import { Dictionary } from '@/types';
import { Component, Vue } from 'vue-property-decorator';
import mixinFilter from '@/pages/mixin-filter.js';

@Component({
  mixins: [mixinFilter],
})
export default class FilterMixin extends Vue {
  get filterValues(): Dictionary<any> {
    return {
      ...this.$route.query,
      ...this.$route.params,
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/list/mixins/filter-mixin.ts